import { Field, Model } from 'serialize-ts';

@Model()
export class AttributeOption {
  @Field()
  id: string;

  @Field()
  name: string;

  @Field()
  totalCount: number;

  @Field()
  value: string;

  @Field()
  code?: string;

  @Field()
  isSelected?: boolean;

  @Field()
  logo?: string;
}

@Model()
export class OptionsRange {
  @Field()
  min: number;

  @Field()
  max: number;
}
